<template>
  <div class="query-list">
    <div class="query-list-content">
      <div v-for="(item, index) in dataArray" :key="index">
        <cell :model="item" :isLast="index == dataArray.length - 1" @onClick="onCellClick(index)"></cell>
      </div>
    </div>
    <div class="query-list-button-container">
      <button class="query-list-button-container-button" :class="[canSubmit ? 'red' : 'pink']" @click="onSubmit">
        提交结果
      </button>
    </div>
  </div>
</template>

<script>
import Cell from '@c/query-list/cell.vue'
import API from '@/api';
import { NavigationTool } from '@/utils/navigation-tool.js'
export default {
  components: { Cell },

  computed: {
    configurationModel() {
      return this.$store.state.configurationModel
    },

    accountModel() {
      return this.$store.state.accountModel
    },

    loginModel() {
      return this.$store.getters['user/getUser']
    },

    dataArray() {
      return this.configurationModel.assessmentArray
    },

    canSubmit() {
      for (const item of this.dataArray) {
        if (!item.isFilled) {
          return false
        }
      }
      return true
    }
  },

  methods: {
    // Action
    onCellClick(index) {
      const assessmentItem = this.dataArray[index]
      NavigationTool.navigateToQuery(assessmentItem)
    },

    onSubmit() {
      if (this.canSubmit) {
        this.submit()
      } else {
        this.$toast('请完成全部问卷再提交')
      }
    },

    // Method
    async submit() {
      const [error, data] = await to(this.submitRequest())
      if (error) {
        this.$toast(error)
        return
      }
      // 删除回答
      this.$store.commit('saveAnswerDataArray', [])
      // 跳转结果
      const isFromQuery = true
      const resultIDArray = data.map((item) => {
        return item.resultId
      })
      const resultIds = resultIDArray.join(',')
      NavigationTool.navigateToResultList(isFromQuery, resultIds)
    },

    // Request
    submitRequest() {
      const answerDataArray = this.$store.state.answerDataArray
      let data = {
        content: JSON.stringify(answerDataArray),
        hospitalId: this.configurationModel.model.hospitalId,
        taskId: this.configurationModel.model.id,
        userInfo: JSON.stringify(this.accountModel.userInfo)
      }
      if (this.loginModel) {
        data.uid = this.loginModel.uid
      }
      return API.submitQuery(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.query-list {
  background-color: #f9f9f9;
  width: 100%;
  height: 100%;

  &-content {
    background-color: #f9f9f9;
    color: #323233;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    white-space: pre-wrap;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    padding: 38px 17px 120px 16px;

    ::-webkit-scrollbar {
      width: 0 !important;
    }

    ::-webkit-scrollbar {
      width: 0 !important;
      height: 0;
    }
  }

  &-button-container {
    background-color: white;
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-button {
      color: white;
      font-size: 16px;
      width: 343px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 22px;
    }
  }
}

.red {
  background-color: #596afd;
}

.pink {
  background-color: #979fe9;
}
</style>
